export default __webpack_public_path__ + "static/media/Grupo_1342.9bf256db.png";